<template>
  <div>
    <b-modal
      ref="modalBankAccounts"
      title="Bank Accounts"
      size="xl"
      scrollable
      no-close-on-esc
      no-enforce-focus
      hide-header-close
      no-close-on-backdrop
      modal-class="fullscreen"
      aria-hidden="false"
    >
      <b-container
        class="scrollable-150px px-4"
        fluid
      >
        <b-row>
          <b-col
            cols="12"
            md="4"
            class="px-1"
            order="2"
            order-md="1"
          >
            <b-form-group
              label="Search"
              label-for="filter_bank_account_searc"
              label-class="font-weight-bolder"
            >
              <b-input
                id="filter_bank_account_searc"
                v-model="tableBankAccount.filter.search"
                type="text"
                placeholder="search here"
                debounce="1000"
                autocomplete="off"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="2"
            class="px-1"
            order="1"
            order-md="2"
          >
            <b-form-group
              label="Partner Code"
              label-for="filter_partner_code"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <b-input
                id="filter_partner_code"
                v-model="businessPartner.partner_code"
                type="text"
                disabled
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="4"
            class="px-1"
            order="1"
            order-md="2"
          >
            <b-form-group
              label="Partner Name"
              label-for="filter_partner_name"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <b-input
                id="filter_partner_code"
                v-model="businessPartner.partner_name"
                type="text"
                disabled
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="2"
            class="px-1"
            order="1"
            order-md="2"
          >
            <b-form-group
              label="TIN"
              label-for="filter_partner_code"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <b-input
                id="filter_partner_code"
                v-model="businessPartner.tin"
                type="text"
                disabled
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            class="px-1 mb-2"
            order="3"
          >
            <!--  @click="onCreateBankAccount" -->
            <b-button
              size="sm"
              variant="success"
              @click.prevent="$refs.bankAccount.createBankAccount(businessPartner)"
            >
              Add Bank Account
            </b-button>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col
            cols="12"
            class="px-1"
          >
            <b-table
              ref="tableBankAccount"
              hover
              small
              striped
              bordered
              responsive
              show-empty
              :stacked="isMobile()"
              :per-page="tableBankAccount.perPage"
              :current-page="tableBankAccount.currentPage"
              :fields="tableBankAccount.fields"
              :items="tableBankAccountProvider"
              :sort-by.sync="tableBankAccount.sortBy"
              :sort-desc.sync="tableBankAccount.sortDesc"
              :sort-direction="tableBankAccount.sortDirection"
              :filter="tableBankAccount.filter"
              :filter-included-fields="tableBankAccount.filterOn"
              :busy="tableBankAccount.busy"
            >
              <template #cell(index)="row">
                {{ tableBankAccount.currentPage * tableBankAccount.perPage - tableBankAccount.perPage + (row.index + 1) }}
              </template>

              <template #cell(active)="row">
                {{ Number(row.value) === 1 ? 'Yes' : 'No' }}
              </template>

              <template #cell()="row">
                <div class="text-md-nowrap">
                  {{ row.value }}
                </div>
              </template>

              <template #cell(action)="{ item }">
                <div class="text-md-nowrap d-flex flex-column flex-md-row justify-content-center">
                  <b-button
                    size="sm"
                    variant="success"
                    @click.prevent="$refs.bankAccount.editBankAccount(item)"
                  >
                    Edit
                  </b-button>
                </div>
              </template>

              <template #table-busy>
                <div class="text-center py-5">
                  <b-icon
                    icon="stopwatch"
                    font-scale="5"
                    animation="cylon"
                  />
                  <p class="h3 py-2">
                    <strong>Loading . . .</strong>
                  </p>
                </div>
              </template>

            </b-table>

          </b-col>
          <b-col
            cols="12"
            md="6"
            class="mt-1 mb-2 px-1"
          >
            <b-select
              v-model="tableBankAccount.perPage"
              :options="tableBankAccount.pageOptions"
              class="w-100 w-md-25"
            />
          </b-col>
          <b-col
            cols="12"
            md="6"
            class="d-flex justify-content-center justify-content-md-end mt-1 px-1"
          >
            <b-pagination
              v-model="tableBankAccount.currentPage"
              pills
              last-number
              first-number
              prev-text="Prev"
              next-text="Next"
              aria-controls="table"
              :total-rows="tableBankAccount.totalRows"
              :per-page="tableBankAccount.perPage"
            />
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer="{ cancel }">
        <b-button
          variant="outline-dark"
          :disabled="state.busy"
          @click="cancel()"
        >
          Close Window
        </b-button>
      </template>
    </b-modal>

    <BankAccount
      ref="bankAccount"
      :business-partner="businessPartner"
      @created="$refs.tableBankAccount.refresh()"
      @updated="bankAccountUpdated"
    />
  </div>
</template>
<script>
import QUERY from 'lodash'

import BankAccount from '@/views/ta/maintenances/business-partners/components/BankAccount.vue'

import MISC from '@/mixins/misc'
import FORMATTER from '@/mixins/formatter'

import { STABankAccount } from '@/services'

export default {
  name: 'BankAccounts',

  components: {
    BankAccount
  },

  mixins: [
    MISC,
    FORMATTER
  ],

  data () {
    return {
      state: {
        editing: false
      },
      businessPartner: {
        id: null,
        partner_code: null,
        partner_name: null,
        tin: null
      },
      tableBankAccount: {
        perPage: 5,
        pageOptions: [5, 10, 25, 50, 100],
        totalRows: 0,
        currentPage: 1,
        sortBy: null,
        sortDesc: true,
        sortDirection: 'desc',
        filter: {
          search: null,
          business_partner: null
        },
        filterOn: [],
        busy: false,
        fields: [
          { mobile: 0, key: 'index', label: '#', class: 'text-center' },
          { mobile: 7, key: 'action', class: 'text-center' },
          { mobile: 1, key: 'created_at', formatter: this.dateTimeShortFormatter, sortable: true },
          { mobile: 2, key: 'bank.bank_name', label: 'Bank' },
          { mobile: 3, key: 'bank_account_number' },
          { mobile: 4, key: 'bank_account_name' },
          { mobile: 5, key: 'active', class: 'text-center' },
          { mobile: 6, key: 'updated_at', formatter: this.dateTimeShortFormatter }
        ].sort(this.scaleOnMobile)
      }
    }
  },

  methods: {

    async tableBankAccountProvider ({ currentPage, perPage, sortBy, sortDesc, filter }) {
      this.tableBankAccount.busy = true
      const payload = this.objectToUrl({
        page: currentPage,
        per_page: perPage,
        sort: sortBy,
        sort_desc: sortDesc,
        filter_text: filter.search,
        bank_accountable: filter.business_partner
      })
      return await STABankAccount.get(payload).then(({ data }) => {
        this.tableBankAccount.totalRows = data.total_rows
        return data.items
      }).catch(() => {
        this.tableBankAccount.totalRows = 0
        return []
      }).finally(() => {
        this.tableBankAccount.busy = false
      })
    },

    showBankAccounts (businessPartner) {
      this.state.editing = false

      this.tableBankAccount.filter = {
        search: null,
        business_partner: businessPartner.id
      }

      this.businessPartner = {
        id: businessPartner.id,
        partner_code: businessPartner.partner_code,
        partner_name: businessPartner.partner_name,
        tin: businessPartner.tin
      }

      this.$refs.modalBankAccounts.show()
    },

    bankAccountUpdated (bankAccount) {
      const tableRowBankAccount = QUERY.find(this.$refs.tableBankAccount.localItems, {
        id: bankAccount.id
      })
      if (tableRowBankAccount) {
        tableRowBankAccount.bank = bankAccount.bank
        tableRowBankAccount.bank_accountable_id = bankAccount.bank_accountable_id
        tableRowBankAccount.bank_accountable_type = bankAccount.bank_accountable_type
        tableRowBankAccount.bank_id = bankAccount.bank_id
        tableRowBankAccount.bank_account_name = bankAccount.bank_account_name
        tableRowBankAccount.bank_account_number = bankAccount.bank_account_number
        tableRowBankAccount.active = bankAccount.active
        tableRowBankAccount.bankAccount = bankAccount.updated_at
      }
    }
  }
}
</script>
